import React, { useRef, useState } from 'react';

const TakeSignature = ({ onClose }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    ctx.stroke();
  };

  const endDrawing = () => {
    setIsDrawing(false);
  };

  return (
    <div>
      <h1 className='mt-2 text-white font-semibold items-center'>Sign here</h1>
      
      {/* Drawing Canvas */}
      <canvas
        ref={canvasRef}
        width={600}
        height={300}
        style={{ border: '1px solid black', backgroundColor: '#CCFFCC' }}
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={endDrawing}
      />
      <button className='mt-4'
        onClick={onClose} 
      >
        Close
      </button>
    </div>
  );
};

export default TakeSignature;
